import * as angular from 'angular';
import TagEditorBridge from './TagEditorBridge';
angular.module('flowingly.components').component('tagEditor', TagEditorBridge);
